import { Button } from '@accure/ui';
import { ChevronRight, LoaderCircle } from 'lucide-react';

import { Link } from '@/components/ui/link';
import type { Alert } from '@/entities/alert';

import { useActionData } from './hooks/use-action-data';

type DetailsLinkButtonProps = {
  alert?: Alert;
};

export function DetailsLinkButton({ alert }: DetailsLinkButtonProps) {
  const actionData = useActionData({ alert });
  if (!actionData) {
    return null;
  }

  if (actionData.isLoading) {
    return (
      <Button disabled size="lg">
        <LoaderCircle className="animate-spin" />
        Loading details link{'\u22EF'}
      </Button>
    );
  }
  if (!actionData.to) {
    return null;
  }
  return (
    <Link to={actionData.to}>
      <Button size="lg" data-testid="alert-get-more-details-button">
        Get more details
        <ChevronRight />
      </Button>
    </Link>
  );
}
